import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <-------------------- Rss Feed Component --------------------->
// ###############################################################
export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 56px);
`;

export const RssFeedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100% - 185px);
  min-height: calc(100vh - 131px);
  padding: 24px 24px 51px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const FormWrapper = styled.div`
  width: 60%;
  padding: 30px 0;
  background-color: white;
  border-radius: 8px;
`;

export const FormTitle = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  padding: 0 25px;
  color: ${({ theme }) => theme.colors.black};
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr 1fr;
  gap: 20px;
  padding: 0 25px;
`;

export const FormFieldWrapper = styled.div`
  ${({ fullWidth }) =>
    fullWidth &&
    `
    grid-column: 1/4;
  `}

  ${({ span }) =>
    span &&
    `
    grid-column: 1/${`span ${span}`};
  `}
`;

export const FormLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const FormTextInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 15px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormMedia = styled.div`
  text-align: center;

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const FormValidationError = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};

  ${({ centerText }) =>
    centerText &&
    `
    text-align: center;
  `}
`;

export const FormUploaderErrorText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
  text-align: center;
`;

export const FormUploaderBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormUploaderBtn = styled(typography.BodyTextOneRegularTypography)`
  display: inline-flex;
  padding: 8px;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px dotted ${({ theme }) => theme.colors.black};
  border-radius: 4px;
  cursor: pointer;

  &:before {
    content: '\\e94a';
    font-family: Icomoon;
    font-size: 15px;
    margin-inline-end: 5px;
  }
`;

export const FormBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormBtn = styled(typography.BodyTextOneRegularTypography)`
  width: 55px;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primaryMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <------------------ End Rss Feed Component ------------------->
// ###############################################################

// ###############################################################
// <------------------------ Media File ------------------------->
// ###############################################################
export const FileItemWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: calc(20% - 8px);
`;

export const FileItemPadding = styled.div`
  padding-top: 100%;
`;

export const FileImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  ${({ opacity }) =>
    opacity &&
    `
    opacity: ${opacity};
  `}
  ${({ blur }) =>
    blur &&
    `
    filter: blur(${blur}px);
  `}
`;

export const ResizedFileImg = styled.img.attrs(({ dimenParamToChange, ratio }) => {
  const width = dimenParamToChange === 'width' ? `calc(100% * ${ratio})` : '100%';
  const height = dimenParamToChange === 'height' ? `calc(100% * ${ratio})` : '100%';

  return {
    style: {
      width,
      height,
    },
  };
})`
  position: absolute;
  top: 0;
  left: 0;
`;

export const VideoIcon = styled.div`
  &:before {
    content: '\\ea15';
    font-family: 'Icomoon';
    font-size: 50px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const ImgDeleteOverlay = styled.div`
  position: absolute;
  top: 0;
  display: none;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.grey500};
  opacity: 0.6;
  cursor: pointer;
`;

export const ImgDeleteIcon = styled.span`
  display: none;
  cursor: pointer;
  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    position: absolute;
    top: 7px;
    right: 7px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const FileItem = styled.div`
  &:hover {
    ${ImgDeleteOverlay} {
      display: block;
    }
    ${ImgDeleteIcon} {
      display: block;
    }
  }
`;

export const ImgPreview = styled.img`
  max-width: 90vw;
  max-height: 90vh;
`;
// ###############################################################
// <---------------------- End Media File ----------------------->
// ###############################################################
